import {format, parseISO} from 'date-fns';

export default {
  displayDate,
  getGraphDateObject
};

function displayDate(date) {
  if (!date) return '';

  let num: any = 1;

  return format(parseISO(date, num), 'dd MMMM yyyy');
}

function getGraphDateObject(date) {
  if (!date) return '';

  let num: any = 1;

  let dateString = format(parseISO(date, num), 'eeeee d MMM');

  let [dayOfWeek, day, month] = dateString.split(' ');

  return {dayOfWeek, day, month};
}
